import { redirect } from 'react-router-dom';
import bootConfig from 'utils/bootConfig';
import { canViewLibrary, canManageLibrary } from 'utils/permissionHelper';
import { getViewPreference, setViewPreference } from 'utils/viewPreference';
import { ROUTES } from 'constants/constants';

const { permissions } = bootConfig.authInfo;

/**
 * Loader for all SPA routes.
 * Guards against users without LIBRARY_USE or LIBRARY_MANAGE permission.
 */
export const libraryViewLoader = async () => {
  if (canViewLibrary(permissions) || canManageLibrary(permissions)) {
    return null;
  }
  return redirect(ROUTES.accessDenied);
};

/**
 * Loader for the IndexPage entry point (/VirtualLibrary) only.
 *
 * Adds a view-preference gate on top of the permission check:
 * - If the user explicitly chose Classic ('classic') → redirect to /library/.
 * - If the user chose Modern ('modern') → stay in the SPA.
 * - If no preference is set (null — first visit, cleared cache) → stay in the
 *   SPA and persist 'modern' so external links (header, homepage) route here
 *   on subsequent visits. This makes the SPA self-sufficient: it works even
 *   before the Classic-side localStorage changes are deployed.
 * - In mock/dev mode: the gate is skipped entirely.
 */
export const indexPageLoader = async () => {
  if (!bootConfig.isMock) {
    const pref = getViewPreference();
    if (pref === 'classic') {
      // User explicitly chose Classic. Navigate away from the SPA entirely.
      // Return null after the replace so the loader completes cleanly in the
      // unlikely event window.location.replace is intercepted or prevented.
      window.location.replace('/library/');
      return null;
    }
    // First visit (null) or returning Modern user — persist the preference so
    // the Classic-side link-rewrite scripts can route here on subsequent visits.
    if (pref !== 'modern') {
      setViewPreference('modern');
    }
  }
  return libraryViewLoader();
};
